import { Eyebrow } from '@/components/ui'
import { manifesto } from '@/content/site'
import { Body } from './Body'
import { Closing } from './Closing'
import { Karta } from './Karta'
import styles from './Manifesto.module.css'
import { Stats } from './Stats'
import { Versus } from './Versus'

/**
 * "01 — Why". The statement scrubs word by word as you read; the highlight phrases warm
 * into iris Boska italic over hand-drawn brush strokes. Then the word behind the name
 * (कर्ता), "Not another dashboard" as a conversation between the old way and Vokarta,
 * the numbers, and a calm closing line. Light theme. Fully readable without motion.
 */
export function Manifesto() {
  return (
    <section
      id="manifesto"
      aria-labelledby="manifesto-title"
      className={styles.root}
      data-theme="light"
    >
      <div className={`container ${styles.inner}`}>
        <div className={styles.statement}>
          <h2 id="manifesto-title" className={styles.eyebrow}>
            <Eyebrow as="span">{manifesto.eyebrow}</Eyebrow>
          </h2>
          <Body />
        </div>
        <Karta />
        <Versus />
        <Stats />
        <Closing />
      </div>
    </section>
  )
}
